// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"acf7e841","122":"07fc7595","155":"e184a451","166":"82dd2ee3","340":"2e0288b9","468":"be17f08d","479":"2ca93b4a","508":"303212db","625":"0f9deee4","647":"653b1f03","753":"f4a372a0","766":"c9317492","842":"1176afbc","937":"dc3b18b6"}[chunkId] + ".chunk.js";
};